import { Modal, ModalBody, ModalFooter, ModalHeader, ModalContent, Button } from "@heroui/react"

const ModalConfirmation = ({ modal, headerText, bodyText, confirmBtnText, cancelBtnText, fn }) => {
  return <Modal isOpen={modal.isOpen} onOpenChange={modal.onOpenChange}>
    <ModalContent>
      <ModalHeader>{headerText}</ModalHeader>
      <ModalBody>{bodyText}</ModalBody>
      <ModalFooter>
        <Button color="" variant="ghost" onPress={modal.onClose}>
          {cancelBtnText || 'Cancel'}
        </Button>
        <Button color="danger" onPress={fn}>
          {confirmBtnText}
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
}

export default ModalConfirmation
